import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import LazyLoader from "./lazyLoader";
import { RecordQuickView } from "../components/home/Dashboard/RecordsQuickView/RecordQuickView";
import ECBSidebarLayout from "../SidebarLayout/ECBSidebarLayout";
import Layout from "../layout/Layout";
import PageNotFound from "../components/pages/pageNotFound";
import AllInspections from "components/home/Inspections/AllInspections/AllInspections";
import Protected from "./protected";
import PublicRoute from "./publicRoutes/PublicRoute";
import ComplainAddress from "../components/home/Dashboard/ComplainAddress";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "components/home/PaymentMethod/CheckoutForm";
import PaymentMethod from "components/home/PaymentMethod/PaymentMethod";
import EmailVerification from "screens/EmailVerification/EmailVerification";
const stripePromise = loadStripe('pk_live_51O1ooDGvYib0wZeFdjzF5OtaGqGqLdXHQFJv2xdHafTWD0HDnkmpxGXtBlWPJ7DBEBGfxfdXMhW5ZUBOE1kPDzem00ebZNZVpu');
// const options = {clientSecret: 'sk_test_51N97B9BUjy6BXHZBILRMfdYGGfRzT2jfwPJz2YyndEOU1nH0fxgnqcoFMfar1z5q859WAumGoQxOSbWISShRmdPh001AFUdlzM'};
// console.log(options)
export default function Index() {

  const [hasAdminId, setHasAdminId] = useState(false);
  const checkAdminId = () => {
    return localStorage.getItem("adminId");
  };
  useEffect(() => {
    setHasAdminId(!!checkAdminId());
  }, []);


  const [hasSubAdminId, setHasSubAdminId] = useState(false);
  const checkSubAdminId = () => {
    return localStorage.getItem("subadminId");
  };
  useEffect(() => {
    setHasSubAdminId(checkSubAdminId());
  }, []);
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/" element={<LazyLoader page="screens/signin/Signin" />} />
      </Route>
      <Route element={<PublicRoute />}>
        <Route
          //
          path="/loginUserName"
          element={<LazyLoader page="screens/LoginUserName/LoginUserName" />}
        />
      </Route>

      <Route element={<PublicRoute />}>
        <Route
          //
          path="/email_verification"
          element={<LazyLoader page="screens/EmailVerification/EmailVerification" />}
        />
      </Route>


      <Route element={<PublicRoute />}>
        <Route
          path="/reset-password/:token"
          element={<LazyLoader page="screens/resetPassword/ResetPassword" />}
        />
      </Route>

      <Route element={<PublicRoute />}>
        <Route
          path="/reset-user/:token"
          element={
            <LazyLoader page="screens/resetLoginUserName/ResetLoginUserName" />
          }
        />
      </Route>
      <Route element={<PublicRoute />}>
        <Route
          path="/password"
          element={<LazyLoader page="screens/Password/Password" />}
        />
      </Route>
      <Route element={<PublicRoute />}>
        <Route
          path="/signup"
          element={<LazyLoader page="screens/Signup/Signup" />}
        />
      </Route>
      <Route path="*" element={<PageNotFound />} />
      <Route element={<Layout />}>
        <Route element={<Protected />}>
          <Route
            path="/client_view"
            element={
              <LazyLoader page="components/home/Dashboard/Notification/Notification" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_BuildingQuickview"
            element={
              <LazyLoader page="components/home/Dashboard/BuildingQuickView/BiuldingQuickView" />
            }
          />
        </Route>
        <Route path="/record_view_all_files" element={<RecordQuickView />} />


        <Route element={<Protected />}>
          <Route
            path="/record_view_dob_cert"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/DOBCERT" />
            }
          />
        </Route>

        <Route element={<Protected />}>
          <Route
            path="/complain_address"
            element={
              <LazyLoader page="components/home/Dashboard/ComplainAddress" />
            }
          />
        </Route>

        <Route path="/complain_address" element={<ComplainAddress />} />

        <Route element={<Protected />}>
          <Route
            path="/calender_sync"
            element={
              <LazyLoader page="components/home/Dashboard/Calender/CalenderSync/RecordGoogle" />
            }
          />
        </Route>

        {/* 
        <Route element={<Protected />}>
          <Route
            path="/payment_method"
            element={
              <LazyLoader page="components/home/PaymentMethod/PaymentMethod" />
            }
          />
        </Route> */}
        {/* <Route element={<Protected />}>
          <Route
            path="/payment_method"
            element={
              <Elements stripe={stripePromise} >
                <CheckoutForm />
              </Elements>
            }
          />
        </Route> */}


        {!hasSubAdminId && (
          <Route element={<Protected />}>
            {/* Define your payment_method route */}
            <Route
              path="/payment_method"
              element={
                <Elements stripe={stripePromise}>
                  <PaymentMethod />
                </Elements>
              }
            />
          </Route>)}



        <Route element={<Protected />}>
          <Route
            path="/payment-status"
            element={
              <LazyLoader page="components/home/PaymentMethod/PaymentStatus" />
            }
          />
        </Route>












        <Route element={<Protected />}>
          <Route
            path="/record_view_deeds"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/DEED" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_deeds"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/DEED" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/account_setting"
            element={
              <LazyLoader page="components/home/Account Settings/Account Settings" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/edit_account_settings"
            element={
              <LazyLoader page="components/home/Account Settings/EditAccountSettings" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/building_list"
            element={
              <LazyLoader page="components/home/Building List/BuildingList" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_dobvalue"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/DOBValue" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_dobtax"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/DOBTax" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_fndyletter"
            element={
              <LazyLoader page="components/home/Dashboard/RecordsQuickView/FNDYLetter" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/swo/Vo"
            element={<LazyLoader page="components/home/DOB/SWO/SWO" />}
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/live-Dob-Complaints"
            element={
              <LazyLoader page="components/home/DOB/Complaints/Complaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/live-Dob-civil-penalties"
            element={
              <LazyLoader page="components/home/DOB/CivilPenalties/CivilPenalties" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/live-Dob-contract-license"
            element={
              <LazyLoader page="components/home/DOB/ContractLicense/ContractLicense" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/overview"
            element={
              <LazyLoader page="components/home/SlogganBannerPages/Overview" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/manageReports"
            element={
              <LazyLoader page="components/home/DOB/Manage Reports/ManageReports" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_insurance"
            element={
              <LazyLoader page="components/home/Dashboard/Insurance/Insurance" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dob-report-by-building"
            element={
              <LazyLoader page="components/home/DOB/Manage Reports/AllReports/DOBViolationByBuilding" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dob-report-by-type"
            element={
              <LazyLoader page="components/home/DOB/Manage Reports/AllReports/DOBByType" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dob-report-gave-plumber"
            element={
              <LazyLoader page="components/home/DOB/Manage Reports/AllReports/GavePlumber" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_calender"
            element={
              <LazyLoader page="components/home/Dashboard/Calender/Calender" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_charts"
            element={
              <LazyLoader page="components/home/Dashboard/Charts/Charts" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB-View"
            element={
              <LazyLoader page="components/home/DOB/Violations/DOBView/DOBView" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB-View-test"
            element={
              <LazyLoader page="components/home/DOB/Violations/DOBView/DOBViewExample" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB-View-work-order"
            element={
              <LazyLoader page="components/home/DOB/Violations/DOBView/WorkOrderDOB/WorkOrderDOB" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/permit-add-work"
            element={
              <LazyLoader page="components/home/Permits/All Permits/WorkOrderDOB/WorkOrderDOB" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_requireddocumentatoin"
            element={
              <LazyLoader page="components/home/Dashboard/Notification/RequiredDocumentation" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_recentreports"
            element={
              <LazyLoader page="components/home/Dashboard/Notification/RecentReports" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_newevents"
            element={
              <LazyLoader page="components/home/Dashboard/Notification/NewEvents" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/record_view_updates"
            element={
              <LazyLoader page="components/home/Dashboard/Notification/Updates" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/corrections_report"
            element={
              <LazyLoader page="components/home/ECB/Corrections/ReportsCorrections/ReportsCorrections" />
            }
          />
        </Route>
        {/* START */}
        <Route element={<Protected />}>
          <Route
            path="/all_Complaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/All Complaints/AllComplaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DEP_Complaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/DEP Complaints/DEPComplaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOH_Compaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/DOH Compaints/DOHCompaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOT_Compaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/DOT Complaints/DOTCompaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="DSNY_Complaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/DSNY Complaints/DSNYComplaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/FDNY_Compaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/FDNY Compaints/FDNYCompaints" />
            }
          />
        </Route>
        {/* <Route element={<Protected />}>
          <Route
            path="/Misc_Compaints"
            element={
              <LazyLoader page="components/home/ECB/Complaints/Misc Compaints/miscCompaints" />
            }
          />
        </Route> */}
        {/* <Route element={<Protected />}>
          <Route
            path="/request"
            element={<LazyLoader page="components/home/ECB/Request/Request" />}
          />
        </Route> */}
        <Route element={<Protected />}>
          <Route
            path="/all_Settliment"
            element={
              <LazyLoader page="components/home/Settliment/AllSettliment/AllSettliment" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/settlinment_Reports"
            element={
              <LazyLoader page="components/home/Settliment/SettlimentReport/SettlinmentReports" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/managed"
            element={<LazyLoader page="components/home/HDP/Managed/Managed" />}
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/order_repair/vacate_orders"
            element={
              <LazyLoader page="components/home/HDP/VacateOrders/VacateOrders" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/top_Uints"
            element={
              <LazyLoader page="components/home/HDP/Top 100 Units/TopUints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/live_Vuilations"
            element={
              <LazyLoader page="components/home/HDP/Live Violations/LiveVuilations" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/violation_Report"
            element={
              <LazyLoader page="components/home/HDP/Violation Report/ViolationReport" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/HDP_Complaints"
            element={
              <LazyLoader page="components/home/HDP/Complaints/Complaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/litigations"
            element={
              <LazyLoader page="components/home/HDP/Litigations/Litigations" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/registerations"
            element={
              <LazyLoader page="components/home/HDP/Registerations/Registerations" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/HDP_Repairs"
            element={
              <LazyLoader page="components/home/HDP/HDP Repairs/HDPRepairs" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/all_Permits"
            element={
              <LazyLoader page="components/home/Permits/All Permits/AllPermits" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB_Permit"
            element={
              <LazyLoader page="components/home/Permits/DOB/DOBPermit" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB_AHV"
            element={
              <LazyLoader page="components/home/Permits/DOB AHV/DOBAHV" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/corrections_view"
            element={
              <LazyLoader page="components/home/ECB/Corrections/AllCorrections/ViewCorrections" />
            }
          />
        </Route>
        {/* <Route element={<Protected />}>
          <Route
            path="/ViolationView"
            element={
              <LazyLoader page="components/home/HDP/ViolationView" />
            }
          />

        </Route> */}
        <Route element={<Protected />}>
          <Route
            path="/building_view_info"
            element={
              <LazyLoader page="components/home/Dashboard/BuildingQuickView/BuildingView/BuildingViewInfopage" />
            }
          />
        </Route>
        <Route element={<Protected />}></Route>
        <Route
          path="/FDNY_Acount"
          element={
            <LazyLoader page="components/home/Permits/FDNY Account/FDNYAcount" />
          }
        />
        <Route element={<Protected />}>
          <Route
            path="/FDNY_COF"
            element={
              <LazyLoader page="components/home/Permits/FDNY COF/FDNYCOF" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dec_Tank"
            element={
              <LazyLoader page="components/home/Permits/DEC Tank/DecTank" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DEP_Permit"
            element={
              <LazyLoader page="components/home/Permits/DEP/DEPPermit" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOH_Primit"
            element={
              <LazyLoader page="components/home/Permits/DOH/DOHPrimit" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOT_Primit"
            element={
              <LazyLoader page="components/home/Permits/DOT/DOTPrimit" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOT_Primit"
            element={
              <LazyLoader page="components/home/Permits/Open Applications/OpenApplications" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dob_now_Applications"
            element={
              <LazyLoader page="components/home/Open Applications/DOBNowApplications" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dob_bis_Applications"
            element={
              <LazyLoader page="components/home/Open Applications/DOBBisApplications" />
            }
          />
        </Route>

        {/* subadmins */}
        <Route element={<Protected />}>
          <Route
            path="/subadmins_all"
            element={
              <LazyLoader page="components/home/Subadmins/Allsubadmins/AllSubadmins" />
            }
          />
        </Route>
        {/* admins */}
        <Route element={<Protected />}>
          <Route
            path="/admins_all"
            element={
              <LazyLoader page="components/home/Admins/Alladmins/Alladmins" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/certificate_Fitness_1"
            element={
              <LazyLoader page="components/home/CertificateOfOccupancy/DOBCertificate" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/open_Applications"
            element={
              <LazyLoader page="components/home/Permits/Open Applications/OpenApplications" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/equipment_Use"
            element={
              <LazyLoader page="components/home/Permits/Equipment Use/EquipmentUse" />
            }
          />
        </Route>

        {!hasAdminId && (
          <Route element={<Protected />}>
            <Route
              path="/Propertytier"
              element={
                <LazyLoader page="components/home/subscription/mainsubscription/PropertyTier" />
              }
            />
          </Route>
        )}

        {/* <Route element={<Protected />}>
          <Route
            path="/Propertytier"
            element={
              <LazyLoader page="components/home/subscription/mainsubscription/PropertyTier" />
            }
          />
        </Route> */}
        <Route element={<Protected />}>
          <Route
            path="/place_Of_Assembly"
            element={
              <LazyLoader page="components/home/Permits/Place of Assembly/PlaceOfAssembly" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/DOB_App"
            element={
              <LazyLoader page="components/home/Permits/DOB LAA Apps/DOBApp" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/electrical_Apps"
            element={
              <LazyLoader page="components/home/Permits/Electrical Apps/ElectricalApps" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/marquee_Tracking"
            element={
              <LazyLoader page="components/home/Permits/Marquee Tracking/MarqueeTracking" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="tenant_services"
            element={
              <LazyLoader page="components/home/Tenant/TenantCard/TenantCard" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="tenant_list"
            element={
              <LazyLoader page="components/home/Tenant/TenantList/TenantList" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="tenant_files"
            element={
              <LazyLoader page="components/home/Tenant/TenantFiles/TenantFiles" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="work_order_list"
            element={
              <LazyLoader page="components/home/Tenant/Work/WorkOrderList" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="insurance_list"
            element={
              <LazyLoader page="components/home/Tenant/InsuranceList/InsuranceList" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="annual_mailings"
            element={
              <LazyLoader page="components/home/Tenant/AnnualMailings/AnnualMailings" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/fdny-inspections"
            element={
              <LazyLoader page="components/home/FDNY/Inspections/FDNYinspections" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/violation-orders"
            element={
              <LazyLoader page="components/home/FDNY/Violation Orders/ViolationOrders" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/fdny_fire_department"
            element={
              <LazyLoader page="components/home/FDNY/FireDepartment/FireDepartment" />
            }
          />
        </Route>

        <Route element={<Protected />}>
          <Route
            path="/cert-fitness"
            element={
              <LazyLoader page="components/home/FDNY/Cert of Fitness/CertFitness" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/permit-accounts"
            element={
              <LazyLoader page="components/home/FDNY/Permit Accounts/PermitAccounts" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/fdny-complaints"
            element={
              <LazyLoader page="components/home/FDNY/Complaints/FDNYcomplaints" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/fdny-incidents"
            element={
              <LazyLoader page="components/home/FDNY/Incidents/FDNYincidents" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/approval-letter"
            element={
              <LazyLoader page="components/home/FDNY/Letter of Approval/ApprovalLetter" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/managed-criminal-summons"
            element={
              <LazyLoader page="components/home/FDNY/Criminal Summons/Managed/ManagedCs" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/live-criminal-summons"
            element={
              <LazyLoader page="components/home/FDNY/Criminal Summons/Live/LiveCs" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/all_inspections_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/AllInspections" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/bolier_inspections_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/DOB/DOBBoiler" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/dep_inspections_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/DEPIns/DEPInspectiuons" />
            }
          />
        </Route>

        <Route element={<Protected />}>
          <Route
            path="/dep_non_compliance"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/DEPNonCompliance/DEPNonCompliance" />
            }
          />
        </Route>

        <Route element={<Protected />}>
          <Route
            path="/elevator_list"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/List/List" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/elevator_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/Elevator/Elevator" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/facade_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/Facade/Facade" />
            }
          />
        </Route>

        <Route element={<Protected />}>
          <Route
            path="/ll33_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL33/LL33" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ll84_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL84/LL84" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ll87_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL87/LL87" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ll97_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL97/LL97" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ll152_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL152/LL152" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ll126_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/LL126/LL126" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/bedbug_report_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/BB/BB" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/parapet_observation_"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/PP/PP" />
            }
          />
        </Route>

        <Route
          path="/custom_inspections_"
          element={
            <AllInspections>
              <LazyLoader page="components/home/Inspections/AllInspections/Custom/Custom" />
            </AllInspections>
          }
        />
        <Route element={<Protected />}>
          <Route
            path="/street_construction_inspections"
            element={
              <LazyLoader page="components/home/Inspections/AllInspections/StreetConstruction/StreetConstruction" />
            }
          />
        </Route>
        <Route
          path="/client_snapshot_generator_"
          element={
            <LazyLoader page="components/home/Reports/Client Snapshot/ClientSnapshot" />
          }
        />
        <Route element={<Protected />}>
          <Route
            path="/dom_ClientSanpshot"
            element={
              <LazyLoader page="components/home/Reports/DOM/DomClientSanpshot" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/ECB_ClientSanphot"
            element={
              <LazyLoader page="components/home/Reports/ECB/ECBClientSanphot" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/reports_corrections"
            element={
              <LazyLoader page="components/home/Reports/Corrections/Corrections" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/reports_settlement"
            element={
              <LazyLoader page="components/home/Reports/Settlement/Settlement" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/file"
            element={<LazyLoader page="components/home/Reports/File/File" />}
          />
          <Route element={<Protected />}></Route>
          <Route
            path="/HPD_voil_Count_Unit"
            element={
              <LazyLoader page="components/home/Reports/HPD Viol Count By Unit/HPDVoilCountUnit" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/annual_safety_mailings_report_generator"
            element={
              <LazyLoader page="components/home/Reports/Mailings/Mailings" />
            }
          />
        </Route>
        <Route element={<Protected />}>
          <Route
            path="/inspection_report_generator"
            element={
              <LazyLoader page="components/home/Reports/Client Snapshot/Inspection Report/InspectionReports" />
            }
          />
        </Route>
        <Route element={<Protected />}></Route>
        <Route
          path="/scheduled_reports"
          element={
            <LazyLoader page="components/home/Reports/Client Snapshot/Scheduled/MainScheuled" />
          }
        />
        <Route element={<Protected />}></Route>
        <Route
          path="/history_report_generator"
          element={
            <LazyLoader page="components/home/Reports/History Report/HistoryReport" />
          }
        />
        <Route element={<Protected />}>
          <Route
            path="/_report_files_"
            element={
              <LazyLoader page="components/home/Reports/File/MainFiles" />
            }
          />
        </Route>
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/fdny-corrections"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/FDNY/Corrections/FDNYcorrections" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/violations"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/DOB/Violations/Violations" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/record_view_ecbhearing"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/Dashboard/ECBHearing/ECBhearing" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/violations_all"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Corrections/AllCorrections/Allcorrections" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/corrections_dob"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Corrections/DOBCorrections/DOBCorrections" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/corrections_fdny"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Corrections/FDNYCorrections/FDNYCorrections" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearing"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingTable/HearingTable" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/allHearing"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/AllHearing/AllHearing" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingDEP"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/Hearing DEP/HearingDEP" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingDOB"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingDOB/HearingDOB" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingDOH"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingDOH/HearingDOH" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/fdny-hearings"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/FDNY/Hearings/FDNYhearings" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingDOT"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingDOT/HearingDOT" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingDSNY"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingDSNY/HearingDSNY" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/hearingFDNY"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/HearingFDNY/HearingFDNY" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/reports"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/Hearings/Reports/Reports" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/all_Dues"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/DUES/ALL DUES/AllDues" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/imposed"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/DUES/Imposed/Imposed" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/default"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/DUES/Default/Default" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/overPaid"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/DUES/OverPaid/OverPaid" />
            </ECBSidebarLayout>
          }
        />
      </Route>
      <Route element={<Protected />}>
        <Route
          path="/savings"
          element={
            <ECBSidebarLayout>
              <LazyLoader page="components/home/ECB/DUES/Savings/Savings" />
            </ECBSidebarLayout>
          }
        />
      </Route>
    </Routes>
  );
}
